export const locationsInfo = [
  { name: 'Todas', value: 'ALL' },
  { name: 'Choshuenco', value: 'Choshuenco' },
  { name: 'Liquiñe', value: 'Liquiñe' },
  { name: 'Neltume', value: 'Neltume' },
  { name: 'Puerto fuy', value: 'Puerto fuy' },
  { name: 'Panguipulli', value: 'Panguipulli' },
  { name: 'Coñaripe', value: 'Coñaripe' },
  { name: 'Lago Neltume', value: 'Lago Neltume' },
]

export const experiencesInfo = [
  { name: 'Todas', value: 'ALL' },
  {
    name: 'Experiencia turística, agroturismo y turismo aventura',
    value: 'AGENCY',
  },
  { name: 'Hoteles, hostales y alojamientos', value: 'HOTEL' },
  { name: 'Bar, restaurant y café', value: 'RESTAURANT' },
  { name: 'Artesanías y productos locales', value: 'ECOMMERCE' },
]
